<style lang="scss">
  .wrapper {
    &.opaque {
      opacity: 0;
    }
  }
</style>

<script>
  /**
   * This component is design to go inside a parent with
   *
   * `overflow: hidden`
   *
   * When the contents of this component are partially out of bounds of the
   * parent the callback with a boolean indicating it's visibility.
   */
  import { onDestroy } from "svelte";

  const { callback, content } = $props();
  let el = $state(null);
  let opaque = $state(false);

  let parent = null;
  let observer = null;

  $effect(() => {
    if (!el) return;
    parent = el.parentElement;

    if (observer) observer.disconnect();
    observer = new IntersectionObserver(
      (entries) =>
        entries.forEach((entry) => {
          const fullyVisible = entry.intersectionRatio === 1;
          opaque = !fullyVisible;
          callback(fullyVisible);
        }),
      {
        root: parent,
        threshold: 1,
      },
    );
    observer.observe(el);
  });

  onDestroy(() => {
    if (observer) observer.disconnect();
  });
</script>

<div class={{ wrapper: true, opaque }} bind:this={el}>
  {@render content()}
</div>
